import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

import * as api from "../../api";
import {useFeedbackTools} from "../../components/FeedbackTools";


export const useGroupsQuery = (groupFilter) => {
    return useQuery({
        queryKey: ['groups', groupFilter],
        queryFn: () => api.Group.getGroups(groupFilter),
        keepPreviousData: true
    })
}

export const useCreateGroup = () => {
    const {t} = useTranslation(["groups"])
    const queryClient = useQueryClient();
    const {showSuccessNotification}  = useFeedbackTools();
    const navigate = useNavigate();

    return useMutation({
        mutationFn: async (data) => await api.Group.createGroup(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['groups']);
            showSuccessNotification(t('query.createSuccess'));
            navigate(`/groups`);
        }
    });
}

export const useDeleteGroup = () => {
    const {t} = useTranslation(["groups"])
    const queryClient = useQueryClient();
    const {showSuccessNotification}  = useFeedbackTools();

    return useMutation({
        mutationFn: async (id) => await api.Group.deleteGroup(id),
        onSuccess: () => {
            queryClient.invalidateQueries(['groups']);
            showSuccessNotification(t('query.deleteSuccess'));
        }
    });
}